import { getCurrentOrder, ICurrentOrder } from './getCurrentOrder';

import { CURRENT_ORDER_LOCAL_STORAGE_KEY } from '../constants';

export function setCurrentOrder(data: Partial<ICurrentOrder>): void {
  const currentOrder = getCurrentOrder() || {};

  localStorage.setItem(
    CURRENT_ORDER_LOCAL_STORAGE_KEY,
    JSON.stringify({ ...currentOrder, ...data }),
  );
}
